import React from "react";
import {bool, oneOf, string} from "prop-types";
import "./index.scss";
import {createPortal} from "react-dom";

const Modal = (props) => {
    const {className, horizontal} = props;
    const size = props.size || "default";
    return <div className={`modal ${size}-size ${className} ${horizontal ? "horizontal" : ""}`}>
        {props.children}
    </div>
}

Modal.propTypes = {
    size: oneOf(["default", "small", "large"]),
    className: string,
    horizontal: bool
}
export const ModalPortal = props => createPortal(
    <div className={"portal"}><Modal {...props}/></div>,
    document.body
);
ModalPortal.propTypes = {
    ...Modal.propTypes
}
export default Modal;

